// extracted by mini-css-extract-plugin
export default {"root":"_1L7t2","small":"_bVMp","normal":"_2SaBY"};